"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = displayValuesFor;
function displayValuesFor(props, moreProps) {
	var currentItem = moreProps.currentItem;

	return currentItem;
}
//# sourceMappingURL=displayValuesFor.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-stockcharts/lib/tooltip/displayValuesFor.js
// module id = 59
// module chunks = 0